var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "publications-block html-content" },
    [
      _c(
        "div",
        { staticClass: "publications-head" },
        [
          _c("h1", [_vm._v(_vm._s(_vm.title))]),
          _c("vue-client-only", [
            _vm.link
              ? _c(
                  "a",
                  { attrs: { href: "/news" } },
                  [
                    _vm.adaptive.isMobile
                      ? [_vm._v("\n          Все\n        ")]
                      : [_vm._v("\n          Все новости\n        ")]
                  ],
                  2
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "vue-client-only",
        [
          !_vm.adaptive.isMobile
            ? _c(
                "div",
                { staticClass: "publications-list" },
                _vm._l(_vm.PUBLICATIONS, function(publication) {
                  return _c("publication-card", {
                    key: publication.id,
                    attrs: { info: publication },
                    nativeOn: {
                      click: function($event) {
                        return _vm.openPublication(publication.id)
                      }
                    }
                  })
                }),
                1
              )
            : _c("swiper", {
                attrs: {
                  dots: "",
                  items: _vm.PUBLICATIONS,
                  "slides-to-show": 1
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var item = ref.item
                      return [_c("publication-card", { attrs: { info: item } })]
                    }
                  }
                ])
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }